export function stringTemplate(
  value: string,
  params?: Record<string, any> | null
) {
  return value.replace(/\{(\w+)\}/g, (match, matchValue) => {
    return params?.[matchValue] ?? match
  })
}
